import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import SearchContext from '~/context/srp/SearchContext';

export default function useRegenerateSearchSessionId() {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const { regenerateSearchSessionId } = useContext(SearchContext);

  // If applied filters changed and now none exist, then start a new search session
  useSubsequentEffect(() => {
    if (Object.keys(appliedFilters).length === 0) {
      regenerateSearchSessionId();
    }
  }, [appliedFilters, regenerateSearchSessionId]);
}
